import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";
import { Minus, Plus } from "lucide-react";
import type { ReactNode } from "react";

import { DocumentTable } from "./table";
import { useEditorReadOnly } from "./fields-context";

export function TableView(props: NodeViewProps) {
	const readOnly = useEditorReadOnly();
	const withPos = (action: (tablePos: number) => void) => {
		const pos = props.getPos();

		if (pos !== undefined) {
			action(pos);
		}
	};

	return (
		<NodeViewWrapper className="doc-table group relative">
			<NodeViewContent<"table"> as="table" />

			{!readOnly && (
				<div
					data-slot="table-actions"
					contentEditable={false}
					className="absolute left-0 top-full z-20 hidden gap-1 pt-1 group-focus-within:flex group-hover:flex"
				>
					<TableControl
						label="Adicionar linha"
						onClick={() => withPos((pos) => DocumentTable.appendRow(props.editor, pos))}
					>
						<Plus />
						linha
					</TableControl>

					<TableControl
						label="Remover linha"
						disabled={props.node.childCount <= 1}
						onClick={() => withPos((pos) => DocumentTable.removeCursorRow(props.editor, pos))}
					>
						<Minus />
						linha
					</TableControl>
				</div>
			)}
		</NodeViewWrapper>
	);
}

interface TableControlProps {
	label: string;
	disabled?: boolean;
	onClick(): void;
	children: ReactNode;
}

function TableControl({ label, disabled = false, onClick, children }: TableControlProps) {
	return (
		<button
			type="button"
			aria-label={label}
			disabled={disabled}
			onMouseDown={(event) => event.preventDefault()}
			onClick={onClick}
			className="flex items-center gap-1 rounded-md border border-border bg-card px-2 py-1 font-sans text-xs text-foreground/70 shadow-card transition-colors hover:bg-foreground/5 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-40 [&_svg]:size-3"
		>
			{children}
		</button>
	);
}
